var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import OtherProductsListing from './OtherProductsListing';
import ProbioticsRoutes from './probiotics/page';
import TreatsRoutes from './treats/page';
var OtherProductsRoutes = [
    {
        path: 'other-products',
        children: [
            { index: true, element: _jsx(OtherProductsListing, {}) },
            {
                path: 'treats',
                children: __spreadArray([], TreatsRoutes, true),
            },
            {
                path: 'probiotics',
                children: __spreadArray([], ProbioticsRoutes, true),
            },
        ],
    },
];
export default OtherProductsRoutes;
